import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const useForbidden = (statusCode) => {
    const [notAllowed, setNotAllowed] = useState(false);
    const message = useSelector((state) => state?.general?.message);

    useEffect(() => {
        if (statusCode || message?.status === 403) {
            setNotAllowed(true);
        } else {
            setNotAllowed(false);
        }
    }, [message]);
    return { notAllowed };
};

export default useForbidden;
